import { Field } from 'redux-form';
import CheckboxGroup from './CheckboxGroup';

const Checkbox = (props) => {
  return <Field name={props.name} component={CheckboxGroup} {...props} />;
}

export default Checkbox;